import { render, staticRenderFns } from "./PriceStepRate.vue?vue&type=template&id=7b04b8c6&scoped=true"
import script from "./PriceStepRate.vue?vue&type=script&lang=js"
export * from "./PriceStepRate.vue?vue&type=script&lang=js"
import style0 from "./PriceStepRate.vue?vue&type=style&index=0&id=7b04b8c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b04b8c6",
  null
  
)

export default component.exports